import Component, { mixins } from 'vue-class-component';
import VueCqrs from '@cqrs/vue-component-cqrs'
import PageBase from '@common/PageBase'
import * as q from './queries'

@Component
export default class VuePageQueries extends mixins(PageBase, VueCqrs) {
	runBrandingQueryV1(organizationUnitId: number)
	{
		const query = q.buildBrandingQueryV1(organizationUnitId)
		this.$query(query)
	}

	runInstanceSetupQueryV1()
	{
		const query = q.buildInstanceSetupQueryV1()
		this.$query(query)
	}

	runOrganizationAdminDetailsQueryV1(tenantId: number)
	{
		const query = q.buildOrganizationAdminDetailsQueryV1(tenantId)
		this.$query(query)
	}

	runOrganizationUnitQueryV1(organizationUnitId: number)
	{
		const query = q.buildOrganizationUnitQueryV1(organizationUnitId)
		this.$query(query)
	}

	runOrganizationUnitsQueryV1()
	{
		const query = q.buildOrganizationUnitsQueryV1()
		this.$query(query)
	}

	runSearchOrganizationUnitQueryV1(organizationUnitId: number, searchPhrase: string)
	{
		const query = q.buildSearchOrganizationUnitQueryV1(organizationUnitId, searchPhrase)
		this.$query(query)
	}

	runSsoConfigurationQueryV1(tenantId: number)
	{
		const query = q.buildSsoConfigurationQueryV1(tenantId)
		this.$query(query)
	}

	runSystemStatsQueryV1()
	{
		const query = q.buildSystemStatsQueryV1()
		this.$query(query)
	}

}
